import { AuthenticationParameters } from 'msal';

export class AppConfig {
	public static AUTH_CLIENT_ID: string = "13461585-f86d-488b-8feb-c8f5adf2e225";
	public static AUTHORITY: string = "https://login.microsoftonline.com/zdk000.onmicrosoft.com";
	public static GRAPH_SCOPES: string[] = ["user.readwrite.all", "group.readwrite.all", "files.readwrite.all"];
	public static AUTH_PARAMETERS: AuthenticationParameters = {
		scopes: AppConfig.GRAPH_SCOPES
	};
	public static SUPER_ADMIN_IDS: string[] = ['607bfb50-dd55-46cf-b92d-6081d86ccb4a'];
	public static PERMITTED_GROUP_IDS: string[] = [
		'5f5f5442-a6df-4409-8c47-7d0d03e84cd6', // いしかわ観光創造塾
		'e2e48889-8e46-4439-a6f2-8827bc67a48e' // 観光コア人材育成スクール
	];
	public static USER_SECUTIRY_GROUP_ID: string = "9f5c4e94-ffdf-43ed-a4b9-5c9c5b4d3b2f"; // 生徒
	public static ADMIN_SECUTIRY_GROUP_ID: string = "75e96224-1dd2-438f-85bd-dc910ec1fd0e"; // 運営
	public static USER_ROOT_FOLDER_NAME: string = '生徒';
	public static ADMIN_ROOT_FOLDER_NAME: string = '運営';

	public static CHANNEL_ID_TO_CHNNAEL_FOLDERNAME: { [key: string]: string; } = {
		"19:ab3cc62e3ef942f58b9156fc93307a6d@thread.skype": "第１講 開講式",
		"19:814e6fdc82f841fe96b1742c74a65310@thread.skype": "第２講 ファシリテーション演習", // 第２講 ファシリテーション演習 or 第２講　ファシリテーション演習
		"19:5f23a0194cfe408bbe2799ba9ee51eb8@thread.skype": "第3講　資源開発フィールドワーク",
		"19:c8136041c6664e96a601dda6d5693f9d@thread.skype": "第4講資源開発フィールドワーク（地元学）",
		"19:235acc1caf774956a22a7ece2d37f7a2@thread.skype": "第5講 戦略的マネジメント ケースメソッドⅠ（ミニケース）",
		"19:920af76387214a1dbb4154038a2661e0@thread.skype": "第6講 インバウンドの取組",
		"19:50069dee20694351880e308a7b1310dc@thread.skype": "第7講 実践的マーケティング論（基礎編）",
		"19:55f5a216d8184bfa9b3a2822bc19b2aa@thread.skype": "第8講 ケースメソッドⅡ",
		"19:166581d2c5894c13857896d29b691a71@thread.skype": "第9講 ケースメソッドⅡ",
		"19:a6962380fb6e4d299660be7d6758b3eb@thread.skype": "第10講 アカウンティング論",
		"19:78f3ab906f404c0ea319d99a7a052acf@thread.skype": "第11講 ファイナンス論",
		"19:44a95660ec8349e1a56d222d08a394fc@thread.skype": "第12講 実践的マーケティング論（発展編）、実践的プランニング論",
		"19:3a42c9f4392d47f19a303475dd421a3f@thread.skype": "第13講 事業計画立案",
		"19:05e37ccd311d48a792230dde5671da2f@thread.skype": "第14講 事業計画立案、修了式",
		"19:67e7b6274548411e98ad5deab86cd8d0@thread.skype": "第01講 開講式",
		"19:70841eaf4f944683878bc77c94303bc7@thread.skype": "第02講 ファシリテーションマネジメント",
		"19:ec0d6bd11ed1442f9d231da8a8b7db68@thread.skype": "第03講 トップリーダーの講話と対話Ⅰ"
	};

	public static CHANNEL_ID_TO_SHORTEN_NAME: { [key: string]: string; } = {
		"19:ab3cc62e3ef942f58b9156fc93307a6d@thread.skype": "2019_SCT_01",
		"19:814e6fdc82f841fe96b1742c74a65310@thread.skype": "2019_SCT_02",
		"19:5f23a0194cfe408bbe2799ba9ee51eb8@thread.skype": "2019_SCT_03",
		"19:c8136041c6664e96a601dda6d5693f9d@thread.skype": "2019_SCT_04",
		"19:235acc1caf774956a22a7ece2d37f7a2@thread.skype": "2019_SCT_05",
		"19:920af76387214a1dbb4154038a2661e0@thread.skype": "2019_SCT_06",
		"19:50069dee20694351880e308a7b1310dc@thread.skype": "2019_SCT_07",
		"19:55f5a216d8184bfa9b3a2822bc19b2aa@thread.skype": "2019_SCT_08",
		"19:166581d2c5894c13857896d29b691a71@thread.skype": "2019_SCT_09",
		"19:a6962380fb6e4d299660be7d6758b3eb@thread.skype": "2019_SCT_10",
		"19:78f3ab906f404c0ea319d99a7a052acf@thread.skype": "2019_SCT_11",
		"19:44a95660ec8349e1a56d222d08a394fc@thread.skype": "2019_SCT_12",
		"19:3a42c9f4392d47f19a303475dd421a3f@thread.skype": "2019_SCT_13",
		"19:05e37ccd311d48a792230dde5671da2f@thread.skype": "2019_SCT_14",
		"19:67e7b6274548411e98ad5deab86cd8d0@thread.skype": "2019_SCTCB_01",
		"19:70841eaf4f944683878bc77c94303bc7@thread.skype": "2019_SCTCB_02",
		"19:ec0d6bd11ed1442f9d231da8a8b7db68@thread.skype": "2019_SCTCB_03"
	};

	public static BUCKET_NAME_PRETASK: string = '事前課題';
	public static BUCKET_NAME_PRETASK2: string = '事前課題２';
	public static BUCKET_NAME_PRETASK3: string = '事前課題３';
	public static BUCKET_NAME_LECTURE: string = '講義';
	public static BUCKET_NAME_POSTTASK: string = '事後課題';

	public static USER_TASK_NAME_CHECK_TASK: string = '課題確認';
	public static USER_TASK_NAME_SUBMIT_REPORT: string = 'レポート提出';
	public static USER_TASK_NAME_CHECK_SCORE: string = '採点結果確認';
	public static USER_TASK_NAME_CHECK_DOCS: string = '講義資料確認';
	public static USER_TASK_NAME_CHECK_VIDEOS: string = '講義動画確認';

	public static ADMIN_TASK_NAME_SCORE_REPORT: string = 'レポート採点';
	public static ADMIN_TASK_NAME_GIVE_LECTURE: string = '講義開催';

	public static USER_TASK_FOLDERNAME_SUBMITREPORT: string = '提出レポート';
	public static USER_TASK_FOLDERNAME_CHECKSCORE: string = '採点結果';


	public static ADMIN_TASK_ITEMS: string[] = [
		"課題作成",
		"課題登録",
		"レポートフォーマット登録",
		"レポート採点", // 開始日-1が提出期限
		"講義資料作成",
		"講義資料登録",
		"講義動画登録",
		"講義開催" // 講義日
	];
	public static USER_TASK_ITEMS: string[] = [
		"課題確認",
		"レポート作成", // 提出期限?
		"レポート提出", // 提出期限
		"採点確認",
		"講義資料確認",
		"講義動画確認",
		"講義参加" // 講義日
	];
}
